import useFetch from '../../../hooks/useFetch';
import { WarehouseOrderStorageFilters } from '../../models/WareHouseOrderStorage';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';

const useWarehouseOrderStorageService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingUpdateWarehouseStorage, setFetchingUpdateWarehouseStorage] = useState(false);
    const [fetchingGetWarehouseOrderStorage, setFetchingGetWarehouseOrderStorage] = useState(false);
    const [fetchingGetWarehouseOrderStorages, setFetchingGetWarehouseOrderStorages] = useState(false);
    const [fetchingStoreWarehouseOrderStorage, setFetchingStoreWarehouseOrderStorage] = useState(false);
    const [fetchingEditWarehouseOrderStorage, setFetchingEditWarehouseOrderStorage] = useState(false);
    const [fetchingCreateWarehouseOrderStorage, setFetchingCreateWarehouseOrderStorage] = useState(false);
    const [fetchingShowWarehouseOrderStorage, setFetchingShowWarehouseOrderStorage] = useState(false);
    const getWarehouseOrderStorage = (quoteId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_STORAGE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingGetWarehouseOrderStorage
        });
    };

    const getAllWarehouseOrderStoragesByOrder = (
        quoteId: number,
        storageFilters: WarehouseOrderStorageFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(storageFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_ALL_WAREHOUSE_ORDER_STORAGES}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(
                ':warehouse_order_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseOrderStorages
        });
    };

    const showWarehouseOrderStorage = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.SHOW_WAREHOUSE_ORDER_STORAGES.replace(':warehouse_order_id', id.toString()),
            setFetching: setFetchingShowWarehouseOrderStorage
        });
    };





    return {
        getWarehouseOrderStorage,
        getAllWarehouseOrderStoragesByOrder,
        showWarehouseOrderStorage,
        fetchingCreateWarehouseOrderStorage,
        fetchingGetWarehouseOrderStorage,
        fetchingGetWarehouseOrderStorages,
        fetchingStoreWarehouseOrderStorage,
        fetchingUpdateWarehouseStorage,
        fetchingEditWarehouseOrderStorage,
        fetchingShowWarehouseOrderStorage
    };
};

export default useWarehouseOrderStorageService;
